module.exports = __webpack_public_path__ + "static/seres-silk-duvet-design-process-b2f38eda61be43ed76e512a520c0712c.mp4";